var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align-h":"center"}},[_c('h2',{staticClass:"product__title"},[_vm._v("Part Details")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.part}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }